import { Tag } from 'antd';
import type { ReportListStatus } from '@/models/report';
import styles from './ReportStatusChip.module.css';

const STATUS_LABEL: Record<ReportListStatus, string> = {
  FINAL: 'Final',
  DRAFT: 'Draft',
  PRELIMINARY: 'Preliminary',
  ADDENDUM: 'Addendum',
};

interface ReportStatusChipProps {
  status: ReportListStatus;
}

export default function ReportStatusChip({ status }: ReportStatusChipProps) {
  return (
    <Tag className={styles.chip} data-status={status}>
      {STATUS_LABEL[status] ?? STATUS_LABEL.DRAFT}
    </Tag>
  );
}
